module.exports = __webpack_public_path__ + "static/media/ostersjomasterskapen_small.9bf5648e.jpg";